// extracted by mini-css-extract-plugin
module.exports = {"container":"seven-build_container_p9ubm","noDataBox":"seven-build_noDataBox_176eZ","icon":"seven-build_icon_22wPW","chartBox":"seven-build_chartBox_2V1gO"};